import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./message.module.scss";
import Button from "@material-ui/core/Button";
import { TbMail } from "react-icons/tb";
import CircularProgress from "components/CircularProgress";
import toFarsiNumber from "util/toFarsiNumber";
import moment from "jalali-moment";
import { Link } from "react-router-dom";
import Popover from "@material-ui/core/Popover";
import Badge from "@material-ui/core/Badge";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { withStyles } from "@material-ui/core/styles";

const Accordion = withStyles({
  root: {
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "0px",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const MessageDropDown = ({
  open,
  data,
  loading,
  userUuid,
  id,
  anchorEl,
  handleRequestClose,
  getNotificationSeen,
}) => {
  const { t, i18n } = useTranslation();
  const [expanded, setExpanded] = useState(0);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleRequestClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      className={classes.dialogRoot}
    >
      <div className={` text-center`} style={{ maxWidth: "100%" }}>
        <div
          className={`${
            i18n.language === "fa"
              ? classes.headerContainer
              : classes.headerContainerLtr
          } mb-4`}
        >
          <h2>{t("notifications.notifications_modal_title")}</h2>
          <Link style={{ textDecoration: "none" }} to={"/app/notifications"}>
            <Button
              variant="contained"
              className="btn btn-primary jr-btn-uptin"
              onClick={handleRequestClose}
            >
              {t("notifications.show_notifications")}
            </Button>
          </Link>
        </div>
        <div className={` ${classes.listContainer}`}>
          <ul className={classes.ulList}>
            {loading ? (
              <CircularProgress />
            ) : (
              <>
                {data?.length > 0 ? (
                  data?.map((notification, index) => (
                    <Accordion square onChange={handleChange(index)}>
                      <AccordionSummary
                        aria-controls="panel1d-content"
                        id="panel1d-header"
                      >
                        <div
                          className={
                            i18n.dir() === "rtl"
                              ? classes.notifContainer
                              : classes.notifContainerLtr
                          }
                          onClick={() => getNotificationSeen(notification.uuid)}
                        >
                          <div className={classes.mailIcon}>
                            {notification.seen_by.indexOf(userUuid) !== -1 ? (
                              <TbMail fontSize={34} />
                            ) : (
                              <Badge color="secondary" variant="dot">
                                <TbMail fontSize={34} />
                              </Badge>
                            )}
                          </div>
                          <div className={classes.textContainer}>
                            <p className={classes.notification}>
                              {notification.subject}
                            </p>
                            <p className={classes.date}>
                              {/* {toFarsiNumber(
                                moment(
                                  notification.created_at,
                                  "YYYY/MM/DD hh:mm"
                                )
                                  .locale("fa")
                                  .format("YYYY/MM/DD  hh:mm")
                              )} */}
                              {i18n.language === "fa"
                                ? toFarsiNumber(
                                    moment(
                                      notification.created_at,
                                      "YYYY/MM/DD"
                                    )
                                      .locale("fa")
                                      .format("YYYY/MM/DD   hh:mm")
                                  )
                                : moment(notification.created_at, "YYYY/MM/DD")
                                    .locale("en")
                                    .format("YYYY/MM/DD   hh:mm")}
                            </p>
                          </div>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        {notification.message}
                      </AccordionDetails>
                    </Accordion>
                  ))
                ) : (
                  <div className="no-users">
                    <div
                      style={{
                        padding: "4rem",
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <TbMail fontSize={40} />
                      {t("notifications.no_notification")}
                    </div>
                  </div>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
    </Popover>
  );
};

export default MessageDropDown;
